import React from "react";
import { useTheme } from "styled-components";
import { BotActiveTrade } from "@shared/types";
import PriceLadder from "common/NewLook/PriceLadder.tsx";
import useBotTradeLadder from "features/bots/NewLook/useBotTradeLadder";
import { useLadderPriceFormat } from "features/trades/NewLook/useTradeLadder.ts";

interface NewLookBotTradeBarProps {
  trade: BotActiveTrade;
  symbol?: string;
  exchange?: string;
  botReverse?: boolean | null;
}

const NewLookBotTradeBar = ({
  trade,
  symbol,
  exchange,
  botReverse,
}: NewLookBotTradeBarProps) => {
  const theme = useTheme();
  const model = useBotTradeLadder(trade, symbol, exchange, botReverse);
  const formatPrice = useLadderPriceFormat(symbol, exchange);
  return (
    <PriceLadder
      model={model}
      formatPrice={formatPrice}
      background={theme.colors.cardBgColor}
    />
  );
};

export default React.memo(NewLookBotTradeBar);
